import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { ICreateOrganization } from './organization.interface';

import { axiosApiInstance } from 'services/config';
import { IOrganization } from 'types';
import { IManageOrganizationRequests } from 'types/domain/organizationUpdate';

class OrganizationApi {
  async createOrganization(
    organizationData: ICreateOrganization,
  ): Promise<IOrganization> {
    const response = await axiosApiInstance.post(
      '/organization/create',
      organizationData,
    );
    return response.data;
  }

  async joinOrganization(organizationId: number): Promise<IOrganization> {
    const response = await axiosApiInstance.post('/organization/join', {
      organizationId,
    });
    return response.data;
  }

  async leaveOrganization(accountId: number, config?: AxiosRequestConfig): Promise<void> {
    await axiosApiInstance.post('/organization/leave', { accountId }, config);
  }

  async deleteOrganization(
    organizationId: number,
    config?: AxiosRequestConfig,
  ): Promise<void> {
    await axiosApiInstance.delete(`/organization/${organizationId}`, config);
  }

  async changesGeneralInformation(
    value: ICreateOrganization,
    token: string | null,
    id: number | undefined,
  ): Promise<IManageOrganizationRequests> {
    const response: AxiosResponse<IManageOrganizationRequests> =
      await axiosApiInstance.put(`/organization/general/${id}`, value, {
        headers: { Authorization: `Bearer ${token}` },
      });
    return response.data;
  }
}

export { OrganizationApi };
